"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChariotContext = exports.ChariotProvider = void 0;
var ChariotProvider_1 = require("./ChariotProvider");
Object.defineProperty(exports, "ChariotProvider", { enumerable: true, get: function () { return ChariotProvider_1.ChariotProvider; } });
var ChariotContext_1 = require("./ChariotContext");
Object.defineProperty(exports, "ChariotContext", { enumerable: true, get: function () { return ChariotContext_1.ChariotContext; } });
var React = require("react");
if (!React)
    throw new Error("React is required for the chariot.js React adaptor.");
